export const alertVariants = {
    achievement: "Achievement"
}